<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: String,
    required: false,
    default: "20"
  },
  borderWidth: {
    type: String,
    required: false,
    default: "2"
  },
  borderColor: {
    type: String,
    required: false,
    default: "#a1a1a1"
  },
  animationDuration: {
    type: String,
    required: false,
    default: "2s"
  }
});

const spinnerStyle = computed(() => ({
  "--width": `${props.size}px`,
  "--height": `${props.size}px`,
  "--border-color": `${props.borderColor}`,
  "--animation-duration": `${props.animationDuration}`,
  "--border-width": `${props.borderWidth}px`
}));
</script>

<template>
  <div class="flex-center w-full overflow-hidden p-2 text-center">
    <span class="loader" :style="spinnerStyle" />
  </div>
</template>

<style scoped>
.loader {
  width: var(--width);
  height: var(--height);
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite;
}

.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border-width: var(--border-width);
  border-style: solid;
  border-color: var(--border-color);
  animation: prixClipFix var(--animation-duration) linear infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}
</style>
